import { withJsonFormsControlProps } from '@jsonforms/react'
import Stack from '@mui/material/Stack'
import InputLabel from '@mui/material/InputLabel'
import Input from '@mui/material/Input'
import InputAdornment from '@mui/material/InputAdornment'

const PriceRangeInput = withJsonFormsControlProps(function (props) {
  const { required, data, handleChange, path } = props
  const onChange = value => { handleChange(path, value) }
  const {min = 0, max = 0} = data || {}
  return <div>
    <InputLabel htmlFor="component-simple">Price Range</InputLabel>
    <Stack direction="row" alignItems="center" spacing={2}>
      <Input {...{
        variant: 'standard',
        type: 'number',
        size: 'small',
        step: 'any',
        min: 0,
        // max: 100 * 1000 * 1000,
        value: toDollars(min),
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
        onChange(event){
          onChange({ min: toCents(event.target.value), max })
        }
      }}/>
      <Input {...{
        variant: 'standard',
        type: 'number',
        size: 'small',
        value: toDollars(max),
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
        step: 'any',
        min,
        onChange(event){
          onChange({ min, max: toCents(event.target.value) })
        }
      }}/>
    </Stack>
  </div>
})
export default PriceRangeInput


function toDollars(cents = 0){
  return (cents / 100).toFixed(2).toString()
    .replace(/.00$/, '')
    .replace(/.(\d)0$/, '.$1')
}

function toCents(float = 0.0){
  if (typeof float === 'string') float = parseFloat(float, 10)
  return float * 100
}
